import React from "react";

const Extras = ({ type, items }) => {
  return (
    <section className="mains">
      <h2 className="extras-heading">{type}</h2>
      {items.map((item, index) => (
        <article className="menu-item" key={index}>
          <div className="extras-name">{item.name}</div>
          
          <strong className="mains-strong">€{item.price_1} - {item.price_2}</strong>
        </article>
      ))}
    </section>
  );
};

export default Extras;